// Forms with their own URL inherit the visibility of the menu that opens them.
const routeAliases = [
  [/^\/millproduc\/newNormativ(?:\/|$)/i, "/millproduc/normativ"],
  [/^\/millproduc\/newProduce(?:\/|$)/i, "/millproduc/produce"],
  [/^\/employees\/contracts(?:\/|$)/i, "/accounts/employees"],
  [/^\/purchases\/addpurchaseinvoice(?:\/|$)/i, "/purchases/detailpurchase"],
  [/^\/purchases\/addImport(?:\/|$)/i, "/purchases/import"],
  [/^\/purchases\/addInvestmentImport(?:\/|$)/i, "/purchases/investmentImport"],
  [/^\/purchases\/NewFarmerPurchase(?:\/|$)/i, "/purchases/FarmerPurchase"],
  [/^\/expences\/addexpensepurchases(?:\/|$)/i, "/expences/expensepurchases"],
  [/^\/expences\/(?:AddRent|officialRent)(?:\/|$)/i, "/expences/rent"],
  [/^\/expences\/(?:AddWages|automaticWages)(?:\/|$)/i, "/expences/wages"],
  [/^\/expences\/AddInteres(?:\/|$)/i, "/expences/interes"],
  [/^\/Sales\/addPos(?:\/|$)/i, "/Sales/pos"],
  [/^\/Sales\/add-Z-sales(?:\/|$)/i, "/Sales/Z-salesdetail"],
  [/^\/Sales\/addProInvoice(?:\/|$)/i, "/Sales/proInvoice"],
  [/^\/Sales\/Addoffer(?:\/|$)/i, "/Sales/offer"],
  [/^\/Sales\/newReturnFromCustomer(?:\/|$)/i, "/Sales/returnFromCustomer"],
  [/^\/Sales\/NewReturnToSupplier(?:\/|$)/i, "/Sales/returnToSupplier"],
  [/^\/accounting\/addaccountingsheets(?:\/|$)/i, "/accounting/accountingsheets"],
  [/^\/accounting\/insertentrysheet(?:\/|$)/i, "/accounting/entrysheet"],
  [/^\/accounting\/insertexitsheet(?:\/|$)/i, "/accounting/exitsheet"],
  [/^\/money\/(?:add|edit)receivables(?:\/|$)/i, "/money/receivables"],
  [/^\/money\/(?:add|edit)payments(?:\/|$)/i, "/money/payments"],
  [/^\/money\/(?:add|edit)withdrawal(?:\/|$)/i, "/money/withdrawal"],
  [/^\/money\/(?:add|edit)transfers(?:\/|$)/i, "/money/transfers"],
  [/^\/money\/(?:add|edit)CapitalDeposit(?:\/|$)/i, "/money/capitalDeposit"],
  [/^\/produc\/newNormativ(?:\/|$)/i, "/produc/normativ"],
  [/^\/produc\/newProduce(?:\/|$)/i, "/produc/produce"],
  [/^\/configuration\/newCompany(?:\/|$)/i, "/configuration/company"],
  [/^\/configuration\/newLicense(?:\/|$)/i, "/configuration/licenses"],
  [/^\/configuration\/bar-tree-renewals(?:\/|$)/i, "/configuration/product-renewals"],
];

const nestedMenuRoutes = [
  "/purchases/purchaseintotal",
  "/purchases/investmentpurchases",
  "/expences/expensepurchases",
  "/Sales/salesintotal",
  "/Sales/advance",
  "/Sales/debitnote",
  "/Sales/creditnote",
];

export function resolveProtectedMenuPath(pathname, moduleName = "") {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (["/", "/dashboard", "/print", "/notes", "/configuration/profile"].includes(path.toLowerCase()) ||
      /^\/support(?:\/|$)/i.test(path)) return null;

  if (/^\/Sales\/Addsalesindetails(?:\/|$)/i.test(path)) {
    return moduleName === "Notary_Module" ? "/notary/salesindetails" : "/Sales/salesindetails";
  }

  for (const [pattern, menuPath] of routeAliases) {
    if (pattern.test(path)) return menuPath;
  }
  for (const menuPath of nestedMenuRoutes) {
    if (path.toLowerCase().startsWith(`${menuPath.toLowerCase()}/`)) return menuPath;
  }
  return path;
}

const addRoutes = [
  /^\/purchases\/(?:addpurchaseinvoice|addImport|addInvestmentImport|NewFarmerPurchase)(?:\/|$)/i,
  /^\/expences\/(?:addexpensepurchases|AddRent|AddWages|AddInteres)(?:\/|$)/i,
  /^\/Sales\/(?:addPos|Addsalesindetails|add-Z-sales|addProInvoice|Addoffer|newReturnFromCustomer|NewReturnToSupplier)(?:\/|$)/i,
  /^\/accounting\/(?:addaccountingsheets|insertentrysheet|insertexitsheet)(?:\/|$)/i,
  /^\/money\/(?:addreceivables|addpayments|addwithdrawal|addtransfers|addCapitalDeposit)(?:\/|$)/i,
  /^\/produc\/(?:newNormativ|newProduce)(?:\/|$)/i,
  /^\/millproduc\/(?:newNormativ|newProduce)(?:\/|$)/i,
  /^\/configuration\/(?:newCompany|newLicense)(?:\/|$)/i,
];

const editRoutes = [
  /^\/money\/(?:editreceivables|editpayments|editwithdrawal|edittransfers|editCapitalDeposit)(?:\/|$)/i,
];

export function resolveMenuRouteAction(pathname) {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (/\/edit(?:\/|$)/i.test(path) || editRoutes.some(pattern => pattern.test(path))) return "edit";
  if (/\/(?:new)(?:\/|$)/i.test(path) || addRoutes.some(pattern => pattern.test(path))) return "add";
  return "view";
}
